
const hasError =  (validationErrors, item) => {
  const IsError =  validationErrors?.find(v => v.field == item);
  // const  IsError="what";
    if (IsError !== undefined) {
      return (
        <span className='font-bold text-[#e11d48] tracking-wide rounded-lg'> {IsError?.message}</span>
      )
    }
};

export default hasError;

